<div class="modal-header blue">
    <div class="container-fluid">
        <div class="row modal-header-row">
            <img class="modal-icon" src="assets/ico/exclamation-triangle-regular.svg" alt="icon">
            <span class="modal-title" id="modal-basic-title">{{currentPersona}} -
                {{'dashboard.persona.new.personaExists' | translate}}
                ({{personas.length}})</span>
        </div>
    </div>
</div>
<div class="modal-body">
    {{personas.length}} {{'dashboard.persona.new.alreadyExistsSentence' | translate}}:
    <table aria-describedby="persona exists table">
        <tr>
            <th id="fullName">{{'dashboard.persona.new.fullName' | translate}}</th>
            <th id="createdAt">{{'dashboard.persona.new.createdAt' | translate}}</th>
            <th id="createdBy">{{'dashboard.persona.new.createdBy' | translate}}</th>
            <th id="personaDetails"></th>
        </tr>
        <tr *ngFor="let persona of personas">
            <td>{{persona.fullName}}</td>
            <td>{{persona.createdAt}}</td>
            <td>{{persona.createdBy}}</td>
            <td><a [routerLink]="'persona/' + persona.identifier" class="greenEye"
                    ngbTooltip="{{'dashboard.personaDetails' | translate}}" tooltipClass="animation-tooltip"
                    placement="top" container="body" triggers="hover">
                    <div aria-label="details" [inlineSVG]="'assets/ico/visibility-green.svg'"></div>
                </a></td>
        </tr>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn modal-btn save" (click)="close()">{{'dashboard.persona.new.skip' |
        translate}}</button>
    <button type="button" class="btn modal-btn save" (click)="confirm()">{{'dashboard.persona.new.continue' |
        translate}}</button>
</div>